const DomUtils = require('../../util/dom_utils');
import LanguageManager from '../language_manager/language_manager';
const getMPAARatingByAge = require('../../util/age_rating');
import StarzPlayerConstants from '../../starzplayer_constants';
module.exports = (function() {
    let isFirstTimeAppear = null;
    let contentDescriptorsDomElem = null;
    return {
        show: show,
        remove: remove
    };
    function show(ageRestriction, contentDescriptors) {
        if (isFirstTimeAppear) return;
        let ratingAndAge = LanguageManager.get('rating') + ' ' + getMPAARatingByAge.getMPAARatingByAge(ageRestriction);
        const html = DomUtils.createElementFromString(require('./content_descriptor.hbs')({
            ageRestriction: ratingAndAge, contentDescriptors: contentDescriptors
        }));
        DomUtils.waitForElement('class', 'bitdash-ctrl', function(success, elem) {
            if (success) {
                elem.parentNode.insertBefore(html, elem.nextSibling);
                contentDescriptorsDomElem = document.getElementById('content_descriptor');
                setTimeout(() => {
                    contentDescriptorsDomElem.classList.add('content_descriptor-opacity-1');
                }, 0);
                isFirstTimeAppear = true;
                remove(); // set time to remove element from DOM
            } else {
                throw Error('cant find elem');
            }
        });
    }
    function remove() {
        if (contentDescriptorsDomElem) {
            setTimeout(() => {
                DomUtils.destroyElementByType('id', 'content_descriptor');
                contentDescriptorsDomElem = undefined;
            }, StarzPlayerConstants.contentDescriptorTime + 1000);
        }
    }
}());



// WEBPACK FOOTER //
// ./src/modules/content_descriptor/content_descriptor.js